import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
import { debounce } from './debounce'
import './scroll'
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

let mm = gsap.matchMedia()

// Function to fade on and off elements
function animateFadeImages() {
  const fadeImageWrappers = document.querySelectorAll('.fade-image-wrapper')

  fadeImageWrappers.forEach((wrapper, index) => {
    const image = wrapper.querySelector('img')

    // Initial state: image is invisible
    gsap.set(image, { autoAlpha: 0 })

    //Make the first image visible at start
    if (index === 0) {
      gsap.to(image, { autoAlpha: 1, duration: 0 })
    }

    // ScrollTrigger for fade on and fade off
    ScrollTrigger.create({
      trigger: wrapper,
      start: 'center center',
      end: 'center center',
      onEnter: () => {
        // Fade in the current image
        gsap.to(image, { autoAlpha: 1, duration: 1 })
        // Fade out the previous image if it exists
        if (index > 0) {
          const previousImage =
            fadeImageWrappers[index - 1].querySelector('img')
          gsap.to(previousImage, { autoAlpha: 0, duration: 1 })
        }
      },
      onEnterBack: () => {
        // Fade in the current image
        gsap.to(image, { autoAlpha: 1, duration: 1 })
        // Fade out the previous image if it exists
        if (index > 0 && index < fadeImageWrappers.length - 1) {
          const previousImage =
            fadeImageWrappers[index + 1].querySelector('img')

          gsap.to(previousImage, { autoAlpha: 0, duration: 1 })
        }
      },
    })
  })
}

function fadeElementsOnScroll() {
  const containers = document.querySelectorAll('.fade-elements')

  containers.forEach((container) => {
    const images = container.querySelectorAll('.fade-element')

    images.forEach((image, index) => {
      gsap.fromTo(
        image,
        {
          y: 50,
          autoAlpha: 0,
        },
        {
          scrollTrigger: {
            trigger: image,
            toggleActions: 'play none none none',
          },
          y: 0,
          autoAlpha: 1,
          delay: index / 1.5,
          duration: 1,
          ease: window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--cubic-bezier-out'),
          onStart: () => image.classList.add('pointer-events-none'),
          onComplete: () => image.classList.remove('pointer-events-none'),
        }
      )
    })
  })
}

const expandLine = () => {
  const lines = document.querySelectorAll('.expand-line')

  lines.forEach((line) => {
    const text = line.parentElement.nextElementSibling
    gsap.fromTo(
      line,
      {
        width: 0,
      },
      {
        scrollTrigger: {
          start: '50px bottom',
          end: '50px bottom',
          trigger: line,
        },
        width: '100%',
        duration: 1.5,
        ease: window
          .getComputedStyle(document.documentElement)
          .getPropertyValue('--cubic-bezier-out'),
        onComplete: () => {
          gsap.to(text, { opacity: 1, x: 0, duration: 1, ease: 'power2.out' })
        },
      }
    )
  })
}

mm.add('(min-width: 1280px)', () => {
  //animateFadeImages()
})
fadeElementsOnScroll()
expandLine()
